import { render, staticRenderFns } from "./FieldWorkplace2Info.vue?vue&type=template&id=1b775bbe&scoped=true&"
import script from "./FieldWorkplace2Info.vue?vue&type=script&lang=js&"
export * from "./FieldWorkplace2Info.vue?vue&type=script&lang=js&"
import style0 from "./FieldWorkplace2Info.vue?vue&type=style&index=0&id=1b775bbe&prod&scoped=true&lang=scss&"
import style1 from "./FieldWorkplace2Info.vue?vue&type=style&index=1&id=1b775bbe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b775bbe",
  null
  
)

export default component.exports